import React from 'react';
import { Container, Flex, Text, Box } from '@chakra-ui/react';
import { SectionCard } from '../SectionCard';

function ReadNext({ data }) {
  return (
    <Box as='section' px={{ base: 20, xl: 0 }} mt={{ base: 30, xl: 60 }}>
      <Container maxW='container.lg' borderTop='2px' borderStyle='dotted' pt={30} px={0}>
        <Text as='h2' textStyle='h2' mb={30}>
          Continue Reading
        </Text>
        <Flex gap={30} direction={{ base: 'column', md: 'row' }}>
          <Flex flex='50%'>
            {data.map((section, index) =>
              index === 0 ? (
                <SectionCard
                  data={{
                    section,
                    aspectRatio: 16 / 9,
                    largerTitle: true,
                    showSectionTag: true,
                  }}
                />
              ) : null,
            )}
          </Flex>
          <Flex flex='50%' direction='column' gap={30}>
            {data.map((section, index) =>
              index !== 0 ? (
                <SectionCard
                  data={{
                    section,
                    aspectRatio: 4 / 3,
                    layout: 'horizontal',
                    largeTitle: true,
                    showSectionTag: true,
                  }}
                />
              ) : null,
            )}
          </Flex>
        </Flex>
      </Container>
    </Box>
  );
}

export default ReadNext;
